import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DefaultDataService, HttpUrlGenerator } from "@ngrx/data";
import { TranslateService } from "@ngx-translate/core";
import { throwError } from "rxjs";
import { catchError, first, map } from "rxjs/operators";
import { AppConfig } from "src/app/config-service/app.config";
import { IAnnounceList, IAnnouncements } from "../models/announcements.model";

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsDataService extends DefaultDataService<IAnnounceList> {

    constructor(
        private translate: TranslateService,
        http: HttpClient,
        httpUrlGenerator:HttpUrlGenerator
    ) {
        super('Announcements', http, httpUrlGenerator);
    }

    headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  
    public getAll = () => {
      let url=
      AppConfig.settings.apiServer.url +
      'api/info/announce?region='
      +AppConfig.settings.city.region;
      return this.http.get<IAnnouncements>(url, {
        headers: this.headers,
        responseType: 'json',
      })
      .pipe(
        map(res => res.announceList),
        first(),
        catchError((error) => {
          if (typeof error === 'string') {
            return throwError(error);
          } else {
            return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
          }
        })
      );
    }
    
}